import {IAutoLoginParams} from "../../../../../common/interfaces/autologin-params.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {IControlCenterData, IMiniOrbitCommunicationAdapter} from "../mini-orbit-communication-adapter.interface";
import {reaction} from "mobx";
import {IDepositWidgetAppLaunchInfo} from "@sparkware/uc-sdk-core/lib/apps/deposit/deposit-widget.interfaces";
import {ActionID, IPerformActionTopicPayload} from "@sparkware/uc-sdk-core";

export const SPORT_COMMUNCATION_OBJECT_NAME = 'sportNativeInterface';
export const SPORT_MINI_ORBIT_COMMUNICATION = 'sport_mini_orbit_communication';

export class SportCommunicationAdapter implements IMiniOrbitCommunicationAdapter {
    constructor(private services: IServiceFactoryExtended) {

        //we trigger this call to overcome NYX - Push Gaming vendor issue when closing game (not redirecting to iframe -> thus onGameClose event not fired)
        this._showCasinoNavbar(true)

        this._subscribe();

        this.services.appLauncher.then(appLauncher => {
            reaction(
                () => appLauncher.isThereRunningApps,
                (isThereRunningApps) => {
                    this._showCasinoNavbar(!isThereRunningApps)
                }
            );
        });
    }

    private _subscribe(): void {
        this.services.sdk.events.onGameOpen(() => this._showCasinoNavbar(false));
        this.services.sdk.events.onGameClose(() => this._showCasinoNavbar(true));
    }

    private get _sportCommunicationObject(): any {
        const adapter = this.services.window.getGlobalProperty(SPORT_COMMUNCATION_OBJECT_NAME);
        if (!adapter) {
            this.services.logger.error(`${SPORT_COMMUNCATION_OBJECT_NAME} adapter is not defined`);
            this.services.analytics.sendTechnicalEvent(SPORT_MINI_ORBIT_COMMUNICATION, "adapter is not defined", SPORT_COMMUNCATION_OBJECT_NAME);
        }
        return adapter;
    }

    private _showCasinoNavbar = (status: boolean): void => {
        this._sportCommunicationObject?.showCasinoNavbar(status);
    };

    openUrlInExternalBrowser = (url: string): void => {
        this._sportCommunicationObject?.openExternalLink(url);
    };

    onUserKicked(logoutReason: number): Promise<IAutoLoginParams> {
        return new Promise<IAutoLoginParams>((resolve, reject) => {
            const cleanUp = () => {
                delete this._sportCommunicationObject.onUserKickedSuccessCallback;
                delete this._sportCommunicationObject.onUserKickedErrorCallback;
            }

            this._sportCommunicationObject.onUserKickedSuccessCallback = (params: IAutoLoginParams) => {
                resolve(params);
                cleanUp();
            };

            this._sportCommunicationObject.onUserKickedErrorCallback = (error) => {
                reject(error);
                cleanUp();
            };

            try {
                this._sportCommunicationObject.onUserKicked(logoutReason)
            } catch (error) {
                reject(error);
                cleanUp();
            }
        });
    }

    openControlCenter = (data: IControlCenterData): void => {
        this._sportCommunicationObject?.performUCAction(JSON.stringify(data));
    };

    openDeposit = (data: IDepositWidgetAppLaunchInfo): Promise<void> => {
        const performUCActionData: IPerformActionTopicPayload<IDepositWidgetAppLaunchInfo> = {
            actionID: ActionID.deposit,
            launchInfo: data,
            correlationID: this.services.tools.getGuid()
        }

        this._sportCommunicationObject?.performUCAction(JSON.stringify(performUCActionData));
        return Promise.resolve();
    };

    onSiteLoaded(): void {}
    onAutologinSuccess(): void {}
    onAutologinFailed(): void {}
}